var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "product-wrapper" },
    [
      _c(
        "div",
        { staticClass: "product-head-section" },
        [
          _c(
            "b-container",
            [
              _c(
                "b-row",
                [
                  _c("b-col", { attrs: { sm: "12" } }, [
                    _c("div", { staticClass: "product-head" }, [
                      _c("div", { staticClass: "image-container" }, [
                        _c(
                          "div",
                          { staticClass: "product-image-wrapper" },
                          [
                            _c("AImage", {
                              attrs: {
                                img: _vm.item.imagesGallery[0],
                                preset: "wineproductdetails",
                                responsive: "",
                                contain: "",
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "main-container" }, [
                        _c(
                          "div",
                          { staticClass: "main-container-content" },
                          [
                            _vm.item.seriesLabel && _vm.showSeries
                              ? _c("div", {
                                  staticClass: "series",
                                  domProps: {
                                    textContent: _vm._s(_vm.item.seriesLabel),
                                  },
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "title titled-product-page" },
                              [
                                _c("h1", [_vm._v(_vm._s(_vm.item.title))]),
                                _vm._v(" "),
                                _c("div", { staticClass: "product-tags" }, [
                                  _vm.item.award_winner
                                    ? _c(
                                        "div",
                                        { staticClass: "special-tag" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "tag-content" },
                                            [
                                              _vm._v(
                                                "\n                        Award Winner\n                      "
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ]),
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", {
                              staticClass: "abstract",
                              domProps: {
                                innerHTML: _vm._s(_vm.item.abstract),
                              },
                            }),
                            _vm._v(" "),
                            _vm.item.product_links &&
                            _vm.item.product_links.length > 0
                              ? _c(
                                  "div",
                                  { staticClass: "product-links-element" },
                                  [
                                    _c("label", { attrs: { for: "links" } }, [
                                      _vm._v(_vm._s(_vm.linksTitle)),
                                    ]),
                                    _vm._v(" "),
                                    _c("b-form-select", {
                                      attrs: {
                                        id: "links",
                                        options: _vm.linkOptions,
                                      },
                                      on: { change: _vm.linkChange },
                                      model: {
                                        value: _vm.currentLink,
                                        callback: function ($$v) {
                                          _vm.currentLink = $$v
                                        },
                                        expression: "currentLink",
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c("ecommerce-cart-add-block", {
                              attrs: {
                                node: _vm.item,
                                overriderrp: _vm.item.rrp,
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                    ]),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.displayTabs
        ? _c(
            "div",
            { staticClass: "wine-details-wrapper" },
            [
              _c(
                "b-container",
                [
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        [
                          _c(
                            "b-tabs",
                            { staticClass: "wine-tabs", attrs: { pills: "" } },
                            [
                              _vm.displayDetailsTab
                                ? _c(
                                    "b-tab",
                                    {
                                      attrs: {
                                        title: "Wine Details",
                                        active: "",
                                      },
                                    },
                                    [
                                      !_vm.productDetailIsComplete
                                        ? _c("deferred-content-placeholder")
                                        : _c(
                                            "div",
                                            {
                                              staticClass:
                                                "wine-details-content",
                                            },
                                            [
                                              _vm.item.description
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "wine-details-element tasting-desc",
                                                    },
                                                    [
                                                      _vm.item.description
                                                        ? _c(
                                                            "WineProductDescription",
                                                            {
                                                              attrs: {
                                                                description:
                                                                  _vm.item
                                                                    .description,
                                                              },
                                                            }
                                                          )
                                                        : _vm._e(),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.hasProductDetails(_vm.item)
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "wine-details-element wine-details",
                                                    },
                                                    [
                                                      _c("WineProductDetails", {
                                                        attrs: {
                                                          "technical-notes":
                                                            _vm.item
                                                              .technical_notes,
                                                          features:
                                                            _vm.item.features,
                                                          "tasting-notes":
                                                            _vm.item
                                                              .tasting_notes,
                                                          "wine-making":
                                                            _vm.item
                                                              .wine_making,
                                                          "previous-tasting-notes":
                                                            _vm.item
                                                              .prev_tasting_notes,
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                            ]
                                          ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              !_vm.productDetailIsComplete ||
                              _vm.item.reviews.length > 0
                                ? _c(
                                    "b-tab",
                                    { attrs: { title: "Reviews & Awards" } },
                                    [
                                      !_vm.productDetailIsComplete
                                        ? _c("deferred-content-placeholder")
                                        : _c(
                                            "div",
                                            {
                                              staticClass:
                                                "product-reviews-container",
                                            },
                                            [
                                              _c("WineProductReviews", {
                                                attrs: {
                                                  reviews: _vm.item.reviews,
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.faqs && _vm.faqs.length > 0
                                ? _c(
                                    "b-tab",
                                    {
                                      attrs: {
                                        title: "FAQ, Shipping & Delivery",
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "shipping-information-wrapper",
                                        },
                                        [
                                          _c("b-container", [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "shipping-information",
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "shipping-content",
                                                  },
                                                  [
                                                    _c("FaqList", {
                                                      attrs: { faqs: _vm.faqs },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            ),
                                          ]),
                                        ],
                                        1
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.relatedProducts.length > 0
        ? _c("relatedProducts", {
            attrs: {
              "related-products": _vm.relatedProducts,
              theme: _vm.productTheme,
              "hover-card-setting": _vm.hoverCardSetting,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }